const pxToRem = (px) => `${px / 16}rem`;
const remToPx = (rem) => `${Number(rem.replace('rem', '')) * 16}px`;
const remToPxNumber = (rem) => remToPx(rem).replace(/px/, '');

module.exports = {
  pxToRem,
  remToPx,
  remToPxNumber,
};
